import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Form from '../../form/form';
import Heading from '../../heading/heading';

const FormBlock = ({ paddingTop, paddingBottom, ...props }) => {
  return (
    <div id={"contact"}>
    <Container bg={'grey'}>
    <Container size={'lg'} gutters bg={'grey'}>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Heading tag={2} text={"Get in touch"} size={'lg'} animate />
        <Form {...props} />
      </Spacing>
    </Container>
    </Container>
    </div>
  );
};

export default FormBlock;

export const query = graphql`
  fragment FormBlock on DatoCmsFormBlock {
    id: originalId
    heading
    paddingTop
    paddingBottom
    hideBorder
    __typename
  }
`;
